import {Init} from '@/core/Init'
import {Attachable} from '@/core/items/base/Attachable'
import {APP_EVT, SERIES_ID} from '@/core/config/constants'
import {Debug} from '@/core/util/Debug'
import {DataBase} from '@/core/services/DataBase'

// removing all auth functionality 2024-06-11
//import {Authenticate} from '@/core/util/Authenticate";

import * as svgjs from '@svgdotjs/svg.js';


class DataWww extends DataBase {

    // initiate auth here as it's only used for www designers.
    // do not need it for office users.
    // removing all auth functionality 2024-06-11
    //protected auth: Authenticate;
    protected caller: string;

    constructor() {

        super();

        Init.emitter.on(APP_EVT.SHOW_SAVE_MODAL, this.showSaveModal);
        Init.emitter.on(APP_EVT.SAVE_CHECK, this.saveCheck);
        Init.emitter.on(APP_EVT.SAVE_DESIGN, this.initSaveDesign);
        Init.emitter.on(APP_EVT.AUTH_MODAL_CLOSED, this.restoreAction);

        // removing all auth functionality 2024-06-11
        //if (Init.app_location == APP_LOCATION.WWW) {
            //this.auth = new Authenticate();
        //}
    }


    /**
     * this is to restore the save or quote request modal once someone
     *  has logged in to author.cedarworks.com
     */
    restoreAction = ():void => {


        // removing all auth functionality 2024-06-11
        // if (this.auth.authLoginStatus !== true) {
        //     this.caller = null;
        //     return;
        // }

        switch (this.caller) {

            case 'showSaveModal':
                this.showSaveModal();
                break;

            case 'showQuoteRequest':
                this.showSaveModal();
                break;

            default:
                // do nothing
                this.caller = null;
        }
    }



    /**
     *
     */
    showSaveModal = (): void => {

        // removing all auth functionality 2024-06-11
        //let auth: boolean = this.auth.authLoginStatus;
        //console.log('auth', auth);

        // if (auth !== true) {
        //
        //     this.caller = 'showSaveModal';
        //
        //     this.auth.showLoginPopup();
        //     //console.log('false');
        //     return;
        // }

        let alert: string[] = this.findOrphanItems();

        if (alert.length > 0) {
            let msg: string = 'The following unattached items need to be removed from your design before saving:';
            for (let i of alert) {
                msg += '<li>' + i + '</li>';
            }

            $('#modal-blank #msg').html(msg);
            $('#modal-blank').modal('toggle');
            return;
        }


        // do not allow small-structure sets to be saved
        switch (Init.series_id) {
            case SERIES_ID.CLASSIC:
            case SERIES_ID.ARCHITECTURAL:
            case SERIES_ID.RUSTIC:
                let too_small: boolean = Init.line.rules.designTooSmall();
                //console.log(too_small);
                if (too_small === true) {
                    let msg:string = 'Small and Medium Structures require a Swing Beam, Bridge, or Monkey Bars for stability. Add one of these accessories or start over with a larger Structure.';
                    $('#modal-blank #msg').html(msg);
                    $('#modal-blank').modal('toggle');
                    return;
                }
                break;
        }

        Init.emitter.emit(APP_EVT.HIDE_OPTION_STATES);

        let modal: string = '#modal-save';

        $(modal + ' .msg-alert').html('');

        $(modal).modal('show');

        let msg: string = 'Enter a name for your design.';

        $(modal + ' .msg').html(msg);
        $(modal + ' #save').show();
        $(modal + ' #save-over').hide();

        //let design_name: string = localStorage.getItem('design_name');
        let design_name: string = Init.getStorage('design_name');
        let email_address: string = localStorage.getItem('email_address');
        //console.log(email_address, Init.user_auth_email);
        if (email_address == undefined || email_address == '') {
            email_address = Init.user_auth_email;
        }

        if (email_address != '') {
            $(modal + ' #save-user-email').val(email_address);
        } else {
            $(modal + ' #save-user-email').trigger('focus');
        }

        if (design_name != '') {
            $(modal + ' #save-design-name').val(design_name);
        }

        Init.emitter.on(APP_EVT.KEY_DOWN_ENTER, this.saveCheck);

    };


    /**
     * see if we have a design already saved under this name
     *
     */
    saveCheck = (): void => {

        Debug.clear();

        let modal: string = '#modal-save';

        $(modal + ' .msg-alert').html('');

        let data: any = {};
        let item_list: Map<string, Attachable> = Init.set_design.items;

        if (item_list.size == 0) {

            $(modal + '  .msg-alert').html(this.createAlert('There are no items in this design.<br>Please create a design before saving it.'));
            return;

        }

        let email_address: any = $(modal + '  #save-user-email').val();
        let design_name: any = $(modal + '  #save-design-name').val();

        if (email_address == '' || email_address == undefined) {

            $(modal + '  #save-user-email').trigger('focus');
            $(modal + '  .msg-alert').html(this.createAlert('Please enter an email address.'));
            return;

        } else if (design_name == '' || design_name == undefined) {

            $(modal + '  #save-design-name').trigger('focus');
            $(modal + '  .msg-alert').html(this.createAlert('Please enter a design name.'));
            return;

        }

        localStorage.setItem('email_address', email_address);
        //Init.setStorage('email_address', email_address);
        Init.set_design.setDesignName(design_name);

        let _that = this;

        data.designName = design_name;
        data.emailAddress = email_address;

        $.ajax({
            type: 'POST',
            url: '/data/saveCheck',
            dataType: 'json',
            data: data
        })
            .done(function (data) {

                if (data.status == 'error') {

                    let alert: string = _that.createAlert(data.errors[0]);
                    $(modal + ' .msg-alert').html(alert);
                    $(modal + '  #save-user-email').trigger('focus');

                } else if (data.status === 'valid') {

                    _that.initSaveDesign();

                } else if (data.status == 'quoted') {

                    let alert: string = _that.createAlert('This design cannot be saved over, as you have requested a quote for this configuration. Enter a new design name if you wish to modify this design.');

                    $(modal + ' .msg-alert').html(alert);

                } else if (data.status == 'overwrite') {

                    let alert: string = _that.createAlert('A design with this name already exists.<br>Do you want to save over it?');
                    $(modal + '  .msg-alert').html(alert);
                    $(modal + '  #save').hide();
                    $(modal + '  #save-over').show();
                    $('#btn-save-over-yes').trigger('focus');
                    Init.emitter.on(APP_EVT.KEY_DOWN_ENTER, _that.initSaveDesign);

                }

            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            });

    };

    /**
     *
     */
    initSaveDesign = (): void => {

        Init.emitter.off(APP_EVT.KEY_DOWN_ENTER, this.initSaveDesign);

        let modal: string = '#modal-save';

        Debug.clear();

        //let item_list: Map<string, Attachable> = Init.set_design.items;

        let email_address: any = $(modal + ' #save-user-email').val();
        let design_name: any = $(modal + ' #save-design-name').val();

        Init.emitter.emit(APP_EVT.SET_GTAG, 'save_design');

        this.saveDesign(design_name, email_address);

    };


    /**
     *
     */
    showQuoteRequest = (): void => {

        // removing all auth functionality 2024-06-11
        //let auth: boolean = this.auth.authLoginStatus;
        //console.log('auth', auth);

        // if (auth !== true) {
        //
        //     this.caller = 'showQuoteRequest';
        //
        //     this.auth.showLoginPopup();
        //     //console.log('false');
        //     return;
        // }

        let panel: string = '#modal-quote-request';

        $('#btn-modal-request-quote').addClass('btn-active');
        $(panel).css({zIndex: 5000});

        $(panel + ' .msg').html('');
        $('#retrieve-design-name').trigger('focus');

    };


    /** **************************************************************
     *                                   GETTERS - SETTERS
     */

}

export {DataWww};

